import React, { createContext, useContext, useState, useEffect } from 'react';
import { gql, useMutation, useLazyQuery } from '@apollo/client';

const ME_QUERY = gql`query Me { me { id email username createdAt mustChangePassword role token } }`;
const LOGIN_MUTATION = gql`mutation LoginByEmail($email: String!, $password: String!) { loginByEmail(email: $email, password: $password) { id email username token mustChangePassword validarEmail role } }`;
const CHANGE_PASSWORD_MUTATION = gql`mutation ChangePassword($currentPassword: String!, $newPassword: String!) { changePassword(currentPassword: $currentPassword, newPassword: $newPassword) { id email username token mustChangePassword validarEmail role } }`;
// Primer ingreso del personal nuevo: codigo que llega al email (desde el 25/10/2026).
const VALIDAR_CODIGO_INGRESO = gql`mutation VCI($codigo: String!) { validarCodigoIngreso(codigo: $codigo) { id email username token mustChangePassword validarEmail role } }`;
const REENVIAR_CODIGO_INGRESO = gql`mutation { reenviarCodigoIngreso }`;

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const [fetchMe] = useLazyQuery(ME_QUERY, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => {
      if (data?.me) {
        setUser(data.me);
        if (data.me.token) localStorage.setItem('nawi_office_token', data.me.token);
      }
      setLoading(false);
    },
    onError: () => {
      localStorage.removeItem('nawi_office_token');
      setUser(null);
      setLoading(false);
    }
  });

  useEffect(() => {
    const token = localStorage.getItem('nawi_office_token');
    if (token) {
      fetchMe();
    } else {
      setLoading(false);
    }
  }, []);

  const login = async (loginFn, email, password) => {
    const { data } = await loginFn({ variables: { email, password } });
    const u = data.loginByEmail;
    localStorage.setItem('nawi_office_token', u.token);
    setUser(u);
    return u;
  };

  const logout = () => {
    localStorage.removeItem('nawi_office_token');
    setUser(null);
    window.location.href = '/';
  };

  const updateUser = (u) => {
    if (u.token) localStorage.setItem('nawi_office_token', u.token);
    setUser(u);
  };

  const isSuperadmin = user?.role === 'superadmin';

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, updateUser, isAuthenticated: !!user, isSuperadmin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export { LOGIN_MUTATION, CHANGE_PASSWORD_MUTATION, VALIDAR_CODIGO_INGRESO, REENVIAR_CODIGO_INGRESO };